import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { PaperUI } from '../../../components';
import FormWrapperWithTitle from '../../../components/UI/Wrapper/Form/FormWrapperWithTitle';

export default makeStyles({
  checkboxContainer: {
    paddingLeft: '11px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
  },
});

export const TitleTable = styled.div`
  margin-bottom:13px ;
  margin-top:25px ;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
`;

export const ContainerPrincipal = styled(PaperUI)`
    padding: 22px;
    height: 100%;
    #resumo{
     display:flex ;
     flex-direction:column ;
     justify-content:start ;
     width:45% ;
      }
 `;

export const WrapperFormWithTitle = styled(FormWrapperWithTitle)`
 margin-bottom: 10px;
 > h3 {
    color: black;
 }
`;
